<template>
	<div id="printDiv" class="printDiv" style="font-size: 15px;">
		<div class="row-me center-all title">
			<span style="font-size: 25px;">月度商品进销存</span>
		</div>
		<div style="margin-top: 20px;">
			<div class="table-print-border" style="font-size: 16px;">
				<div class="row-me">
					<div class="table-print-header">药品名称</div>
					<div class="table-print-header">售价</div>
					<div class="table-print-header">单位</div>
					<div class="table-print-header">批号</div>
					<div class="column-me row-center" style="flex: 3;">
						<div class="table-print-header width100Per">期初</div>
						<div class="row-me width100Per">
							<div class="table-print-header">数量</div>
							<div class="table-print-header">成本</div>
							<div class="table-print-header">金额</div>
						</div>
					</div>
					<div class="column-me row-center" style="flex: 3;">
						<div class="table-print-header width100Per">入库</div>
						<div class="row-me width100Per">
							<div class="table-print-header">数量</div>
							<div class="table-print-header">成本</div>
							<div class="table-print-header">金额</div>
						</div>
					</div>
					<div class="column-me row-center" style="flex: 3;">
						<div class="table-print-header width100Per">出库</div>
						<div class="row-me width100Per">
							<div class="table-print-header">数量</div>
							<div class="table-print-header">成本</div>
							<div class="table-print-header">金额</div>
						</div>
					</div>
					<div class="column-me row-center" style="flex: 3;">
						<div class="table-print-header width100Per">期末</div>
						<div class="row-me width100Per">
							<div class="table-print-header">数量</div>
							<div class="table-print-header">成本</div>
							<div class="table-print-header">金额</div>
						</div>
					</div>
				</div>
				<div class="row-me" v-for="(item,index) in tableData" :key="index">
					<div class="table-print-cell">{{item.name}}</div>
					<div class="table-print-cell">{{item.salePrice}}</div>
					<div class="table-print-cell">{{item.unit}}</div>
					<div class="table-print-cell">{{item.batchNo}}</div>
					<div class="table-print-cell">{{item.beginningNums}}</div>
					<div class="table-print-cell">{{item.beginningCost}}</div>
					<div class="table-print-cell">{{item.beginningAmount}}</div>
					<div class="table-print-cell">{{item.inStorageNums}}</div>
					<div class="table-print-cell">{{item.inStorageCost}}</div>
					<div class="table-print-cell">{{item.inStorageAmount}}</div>
					<div class="table-print-cell">{{item.outStorageNums}}</div>
					<div class="table-print-cell">{{item.outStorageCost}}</div>
					<div class="table-print-cell">{{item.outStorageAmount}}</div>
					<div class="table-print-cell">{{item.endNums}}</div>
					<div class="table-print-cell">{{item.endCost}}</div>
					<div class="table-print-cell">{{item.endAmount}}</div>
				</div>
			</div>
		</div>
		<button v-show="false" id="btnPrint" v-print="'#printDiv'"></button>
	</div>
</template>

<script>
	import print from 'print-js'
	export default {
		components: {

		},
		props: {
			tableData: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {

			}
		},
		// 侦听器
		watch: {

		},
		// 计算属性
		computed: {

		},
		// html加载完成之前
		created() {

		},
		// html加载完成后执行。
		mounted() {

		},
		// 事件方法执行
		methods: {
			startPrint() {
				this.$nextTick(() => {
					document.getElementById("btnPrint").click();
				})
			}
		},
	}
</script>

<style lang="scss" scoped>
	/*去除页眉页脚*/
	@page {
		size: auto;
		/* auto is the initial value */
		margin: 3mm;
		/* this affects the margin in the printer settings */
	}

	html {
		background-color: #FFFFFF;
		margin: 0;
		/* this affects the margin on the html before sending to printer */
	}

	body {
		border: solid 1px blue;
		margin: 10mm 15mm 10mm 15mm;
		/* margin you want for the content */
	}

	.printDiv {
		padding: 10px;

		.title {
			margin-top: 20px;
		}
	}
</style>
